import { getInitials } from "utils/utils";

function UserAvatar(props: { fullName: string; classList?: string }) {
  const { fullName, classList } = props;
  const initials = getInitials(fullName);

  const elementClassNames = `w-full h-full flex items-center justify-center uppercase cursor-default bg-ciq-gray-300/60 text-ciq-fg ${classList}`;

  return (
    <div className={elementClassNames} title={fullName}>
      {initials}
    </div>
  );
}

export default UserAvatar;
